export default {
  'clocks': [
    'clock0900_1300',
    'clock1400_1800'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email'
  ],
  'requiredFields': {
    'default': [
      'Location',
      'Company',
      'VATNumber'
    ], 'cooperation': [
      'Company',
      'RequestTopic',
      'Location',
      'VATNumber'
    ],
    'consulting': [
      'Company',
      'RequestTopic',
      'Location',
      'VATNumber'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'Location',
      'VATNumber'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'Location',
      'VATNumber'
    ],
    'other': [
      'Location'
    ],
  }
}
